import React from 'react'
import { withPrefix } from 'gatsby';
import s from './index.module.css'

const EstoyObligadoAAportarAMiAfp = () => {
  return (
    <div className={'containerWrap'}>
      <div className={`flex direction-column direction-row@lg`}>
        <div className={`w-100 w-50@lg order-2 order-1@lg tw-mt-14 tw-mt-0@lg`}>
          <img
            src={withPrefix('/images/man-computer.svg')}
            alt="man-computer"
            className={`${s.imagenBox3} ${s.elementBottom}`}
          />
        </div>

        <div className={`w-100 w-50@lg order-1 order-2@lg`}>
          <div className="c-gray--4 tw-mt-16@lg tw-mb-2 tw-mb-4@lg center left@lg">
            <h3 className="font-family-secondary fw-7 tw-f-20 tw-f-24@lg">
              ¿Estoy obligado a aportar a mi AFP?
            </h3>
          </div>

          <div className="c-gray--4 tw-mb-4 tw-mb-4@lg center left@lg">
            <p className="font-family-primary  fw-0 tw-f-16 tw-f-16@lg">
              Si eres trabajador dependiente, es decir, si estás en planilla
              debes por ley aportar obligatoriamente a tu fondo personal, el
              cual servirá para financiar tu futura pensión de jubilación.{' '}
            </p>
          </div>

          <div className="tw-mb-4 tw-mb-4@lg">
            <p className="font-family-secondary fw-6 tw-f-18 tw-f-18@lg">
              El aporte también incluye un:
            </p>
          </div>

          <div className="flex items-center">
            <div className="brad-4 border border-2 tw-p-6 tw-pr-20">
              <ul className={`bulletList-0 font-family-primary m-0 p-0`}>
                <li className="tw-mb-2">Seguro de invalidez</li>
                <li className="tw-mb-2">Sobrevivencia</li>
                <li className="tw-mb-0">Gastos de sepelio</li>
              </ul>
            </div>

            <div className={`brad-pill border border-2 tw-p-2 tw-pb-1 bg-white ${s.iconArrow}`}>
              <img
                src={withPrefix('/images/jubilacion-y-pension/ico-arrow-right.svg')}
                alt="ico-arrow-right"
                className={`${s.imagenBox7}`}
              />
            </div>
          </div>

          <div className="tw-mt-4 tw-mt-4@lg">
            <p className="font-family-primary fw-4 tw-f-18 tw-f-18@lg">
              ...además de la comisión que cobra la AFP.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
};

export default EstoyObligadoAAportarAMiAfp;
